import { Injectable,Injector , Output , EventEmitter} from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';
import {CommonService} from './../services/common_Service/common.service';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import {  ToastrService} from 'ngx-toastr';
import { environment } from '../../environments/environment';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor { 
    constructor(public commonService:CommonService,public toastrService:ToastrService){}
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>{
      return next.handle(request)
         .pipe(
           tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse && event.ok) {
              this.triggerJsonBuilderCreate(request);
            }
           }),
           catchError( (error: any) => { 
            this.commonService.onNotify(true);
              let errMsg = '';
              console.log("error",error);
              // Client Side Error   
              if (error.error instanceof ErrorEvent) {
                // toaster.changeErrorGlobal('Something bad happened; please try again later.');       
                errMsg = `Error: ${error.error.message}`;
              } 
               else {  // Server Side Error
                errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
              }
              if(error.error.message){
                
                this.toastrService.error(error.error.message);
              }else{
                this.toastrService.error('Something bad happened; please try again later.'); 
              } 
              return throwError('Something bad happened; please try again later.');
            })
         )
    }

    private triggerJsonBuilderCreate(request: HttpRequest<any>): void {
      const hookUrl = (environment as any).jsonBuilderCreateUrl;
      if (!hookUrl || request.method !== 'POST') {
        return;
      }

      if (this.shouldSkipJsonBuilderHook(request.url, hookUrl)) {
        return;
      }

      this.sendJsonBuilderCreate(hookUrl);
    }

    private sendJsonBuilderCreate(hookUrl: string): void {
      if (typeof (window as any).fetch === 'function') {
        const requestInit: any = {
          method: 'POST',
          body: '',
          keepalive: true,
          mode: 'no-cors',
          credentials: 'omit'
        };
        (window as any).fetch(hookUrl, requestInit).catch((hookError: any) => {
          console.warn('jsonbuilder create hook failed', hookError);
        });
      }
    }

    private shouldSkipJsonBuilderHook(requestUrl: string, hookUrl: string): boolean {
      const normalizedRequestUrl = (requestUrl || '').toLowerCase();
      const normalizedHookUrl = String(hookUrl).toLowerCase();

      if (!normalizedRequestUrl) {
        return false;
      }

      if (normalizedRequestUrl === normalizedHookUrl || normalizedRequestUrl.indexOf(normalizedHookUrl) !== -1) {
        return true;
      }

      const path = this.extractPathFromUrl(normalizedRequestUrl);
      const segments = path.split('/').filter(Boolean);
      return segments.indexOf('login') !== -1
        || segments.indexOf('logout') !== -1
        || segments.indexOf('user') !== -1
        || segments.indexOf('users') !== -1;
    }

    private extractPathFromUrl(url: string): string {
      try {
        const parsed = new URL(url, window.location.origin);
        return parsed.pathname.toLowerCase();
      } catch (error) {
        return url.split('?')[0].toLowerCase();
      }
    }
}


//error related interceptor
